import visaImage from "../../../Assets/Blogs/PakistanTrekkingVisa.png";
import ExploreBaltistan from "../../../Assets/Blogs/ExploreBaltistaValley.png";
import K2ViewPoint from "../../../Assets/Blogs/K2ViewPoint.png";
import masoorRockImage from "../../../Assets/Blogs/MasoorRock.jpeg";

const blogData = [
  {
    id: 1,
    title: "K2 View Point – A Breathtaking Experience",
    thumbnail: K2ViewPoint,
    description: "Explore the majestic viewpoint of K2 with panoramic views and thrilling adventure...",
    path: "/Blogs/K2ViewPoint"
  },
  {
    id: 2,
    title: "Exploring Baltistan Valley",
    thumbnail: ExploreBaltistan,
    description: "Discover ancient forts, beautiful landscapes, and unique Balti culture in Baltistan...",
    path: "/Blogs/BaltistaValley"
  },
  {
  id: 3,
  title: "How to Apply for Pakistan Trekking Visa 2026",
  thumbnail: visaImage,
  description:
    "Complete step-by-step guide for obtaining a Pakistan Trekking Visa for K2 Base Camp and Gondogoro La Trek in 2026.",
  path: "/Blogs/VisaInformation"
},
{
  id: 4,
  title: "Masoor Rock Hike – A Hidden Adventure in Baltistan",
  thumbnail: masoorRockImage,
  description:
    "Discover the breathtaking Masoor Rock Hike near Skardu, featuring stunning landscapes, panoramic views, and one of Baltistan's most unique natural wonders.",
  path: "/Blogs/MasoorRockHike"
},
];

export default blogData;
